"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Config_1 = require("../Config/Config");
const FetchProxy_1 = require("../Utility/FetchProxy");
class RepairOrder {
    async get(repairOrderId) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/repair_order/get?repairOrderId=${repairOrderId}`).auth().fetch();
            return await res.json();
        }
        catch (err) {
            throw new Error(`Failed to get repair order: status ${err.message}`);
        }
    }
    async repairOrderInProgressList(data) {
        try {
            const listData = Object.assign({}, data);
            const list = new URLSearchParams(listData).toString();
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/repair_order/in_progress_list?${list}`).auth().fetch();
            return await res.json();
        }
        catch (err) {
            throw new Error(`Failed to get repair order InProgressList: status ${err.message}`);
        }
    }
    async quotationList(data) {
        try {
            const listData = Object.assign({}, data);
            const list = new URLSearchParams(listData).toString();
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/repair_order/quotation_list?${list}`).auth().fetch();
            return await res.json();
        }
        catch (err) {
            throw new Error(`Failed to get repair order quotationList: status ${err.message}`);
        }
    }
    async exportReport(data) {
        try {
            const res = await new FetchProxy_1.default(`${(0, Config_1.default)().backend.base_url}/report/export/order/record`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(data)
            }).fetch();
            return await res.blob();
        }
        catch (err) {
            throw new Error(`export report fail: status ${err.message}`);
        }
    }
}
exports.default = RepairOrder;
//# sourceMappingURL=RepairOrder.js.map